module.exports = __webpack_public_path__ + "static/media/both2x.95dff42c.png";